// App Under Test Configuration
// Change this setting to switch between login page layouts for testing

const config = {
  // Login layout: 'A' (classic centered card) or 'B' (split-screen)
  loginLayout: 'A'
};

export default config;
